import React from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { isProbationUser } from '../../utils/roles';

function Header({ user, onSignOut, impersonation, onStopImpersonation }) {
  // Cosmetic gate only — /api/submissions/coverage returns 403 regardless. This
  // keeps the page from being advertised to partner users as a dead end.
  const showSubmissions = isProbationUser(user?.global_roles, user?.is_superuser);

  return (
    <header className="spa-header">
      {impersonation && (
        <div className="spa-header__impersonation-banner">
          <span>
            Viewing as <strong>{user?.email}</strong>
          </span>
          <button
            type="button"
            className="spa-header__impersonation-btn"
            onClick={onStopImpersonation}
          >
            Return to my account
          </button>
        </div>
      )}
      <div className="spa-header__content">
        <div className="spa-header__brand">
          <Link to="/dashboard" className="spa-header__logo">
            <img src="/img/logo_sidebar.png" alt="Mobius" className="spa-header__logo-img" />
          </Link>
        </div>

        <Dropdown id="spa-header-menu" pullRight className="spa-header__menu">
          <Dropdown.Toggle className="spa-header__menu-toggle">
            <i className="fa fa-bars" aria-hidden="true" />
          </Dropdown.Toggle>
          <Dropdown.Menu className="spa-header__menu-dropdown">
            <MenuItem header>NAVIGATION</MenuItem>
            <MenuItem eventKey="dashboard" href="/dashboard">
              Dashboard
            </MenuItem>
            <MenuItem eventKey="validator" href="/validate">
              Validator
            </MenuItem>
            <MenuItem eventKey="activity" href="/validate/activity">
              Validation Activity
            </MenuItem>
            {showSubmissions && (
              <MenuItem eventKey="submissions" href="/submissions">
                Submissions
              </MenuItem>
            )}
            <MenuItem eventKey="cohort" href="/predictive">
              Cohort Insights
            </MenuItem>

            <MenuItem divider />
            <MenuItem header>MY ACCOUNT</MenuItem>
            <MenuItem eventKey="settings" href="/settings/accounts">
              Account Settings
            </MenuItem>
            <MenuItem eventKey="password" href="/settings/password">
              Change Password
            </MenuItem>
            <MenuItem eventKey="signout" onClick={onSignOut}>
              Sign Out
            </MenuItem>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </header>
  );
}

export default Header;
